import { NgModule } from '@angular/core';
import { ConsumptionsChartComponent } from './consumptions-chart.component';
import { SharedModule } from '../shared.module';
import { CommonModule } from '@angular/common';
import { ISChartComponent } from '../is-chart/is-chart.component';
import { ISChartModule } from '../is-chart/is-chart.module';

@NgModule({
  declarations: [
    ConsumptionsChartComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ISChartModule
  ],
  exports: [
    ConsumptionsChartComponent
  ]
})
export class ConsumptionsModule { }
